import { Form, Formik } from "formik";
import FormField from "../../forms/FormField";
import * as Yup from "yup";
import { TailwindSpinner } from "../../Spinner/Spinner";
import { useEffect, useMemo, useRef, useState } from "react";
import { useGetCampaignTypes } from "../../../hooks/Query/useGetCampaignType";
import { useGetCampaignReport } from "../../../hooks/Query/useGetChampaignReport";
import { useDownloadCampaignReport } from "../../../hooks/Query/useDownloadCampaignReport";
import MemberEnrollmentTable from "../../MemberEnrolements/MemberEnrolmentTable";
import { CampaignReportColumn } from "../../Table/TableColums";
import { DownloadModal } from "../../DownloadModal";
import { toast } from "react-toastify";
import { downloadFile } from "../../../utils/downloadFile";

const validationSchema = Yup.object({
  rule: Yup.string().required("Rule is required"),
  campaign: Yup.string().required("Campaign is required"),
  status: Yup.string().required("Status is required"),
  view: Yup.string().required("View is required"),
  limit: Yup.string(),
});
export default function CreateCampaignReport() {
  const formikRef = useRef();
  const [formData, setFormData] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [showDownloadOption, setShowDownloadOption] = useState(false);
  const { data: campaign_types, isLoading } = useGetCampaignTypes();
  const [page, setPage] = useState();
  const [campaignList, setCampaignList] = useState();
  const [payloadData, setPayloadData] = useState();
  const [campaignReportData, setCampaignReportData] = useState();
  const [totalPage, setTotalPage] = useState(0);
  const payload = `rule_type=${formData?.rule}&status=${formData?.staus}&campaign_type=${formData?.campaign}&view=${formData?.view}&count=1`;
  const { data: downloadData, isLoading: loading } = useDownloadCampaignReport({
    payload: payloadData,
  });

  const [shouldDownload, setShouldDownload] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState("");

  const {
    data: campaignreport,
    isFetching: loadingReport,
    refetch,
  } = useGetCampaignReport({
    payload: payloadData,
    page: page,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (formikRef.current?.values) {
        setFormData(formikRef.current.values);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (formData?.limit === "All") {
      setOpenModal(true);
      setShowDownloadOption(false);
    }
  }, [formData]);
  const defaultCampaign = { Code_id: "0", Decode_description: "All" };

  useEffect(() => {
    if (campaignreport && !loadingReport) {
      setCampaignReportData(campaignreport?.data?.data);
      setTotalPage(campaignreport?.data?.totalPage);
    }
  }, [campaignreport, loadingReport]);

  useEffect(() => {
    if (!isLoading && campaign_types?.data?.data) {
      setCampaignList([defaultCampaign, ...campaign_types.data.data]);
    }
  }, [campaign_types, isLoading]);

  const campaignTypes = useMemo(
    () =>
      campaignList?.map(({ Code_id, Decode_description }) => ({
        value: Code_id,
        label:
          Decode_description.charAt(0).toUpperCase() +
          Decode_description.slice(1).toLowerCase(),
      })) || [],
    [campaignList]
  );

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
    refetch();
  };
  const handleSubmit = (values) => {
    setPayloadData(values);
    setPage(1);
  };
  const handleShowDownloadReport = (value) => {
    if (
      value?.rule === "" ||
      value?.campaign === "" ||
      value?.view === "" ||
      value?.status === ""
    ) {
      return toast.error("Kindly fill all required filleds.");
    } else {
      setShowDownloadOption(!showDownloadOption);
    }
  };

  const handleDownloadReport = (values, format) => {
    if (!values) {
      toast.error("An error occurred");
      return;
    }

    setPayloadData(values);
    setDownloadFormat(format);
    setShouldDownload(true);
  };

  useEffect(() => {
    if (shouldDownload && downloadData?.data?.data?.length > 0) {
      downloadFile({
        data: downloadData?.data?.data,
        format: downloadFormat,
        // fileName: "campaign_report",
        fileName:`FirstRewards Campaign Report`

      });

      setShouldDownload(false);
    } else if (
      shouldDownload &&
      !loading &&
      !downloadData?.data?.data?.length
    ) {
      toast.warning("No data available to download.");
      setShouldDownload(false);
    }
  }, [downloadData, shouldDownload, downloadFormat, loading]);

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-6 bg-white rounded-lg">
      <div className="mb-6">
        <h1 className="text-lg font-medium text-gray-900">Campaign Report</h1>
        <p className="text-grey-200 text-sm">
          View all campaign report in the program
        </p>
      </div>

      <Formik
        innerRef={formikRef}
        initialValues={{
          rule: "",
          campaign: "",
          status: "",
          view: "Detail",
          limit: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ values }) => {
          return (
            <Form className="md:w-[711px] relative h-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                <FormField
                  label="Rule Type"
                  name="rule"
                  type="select"
                  options={[
                    { value: "0", label: "Auction" },
                    { value: "1", label: "Campaign" },
                    { value: "2", label: "Sweepstake" },
                  ]}
                  required={true}
                />
                <FormField
                  label="campaign"
                  name="campaign"
                  type="select"
                  options={campaignTypes}
                  disabled={!values.rule}
                  required={true}
                />

                <FormField
                  label="status"
                  name="status"
                  type="select"
                  options={[
                    { value: "0", label: "Active" },
                    { value: "1", label: "Completed" },
                    { value: "2", label: "All" },
                  ]}
                  disabled={!values.campaign}
                  required={true}
                />
                <FormField
                  label="View"
                  name="view"
                  type="select"
                  options={[
                    { value: "1", label: "Detail" },
                    { value: "2", label: "Summary" },
                  ]}
                  required={true}
                />
                {showDownloadOption && (
                  <FormField
                    label="Download Limit"
                    name="limit"
                    type="select"
                    options={[
                      { value: "100000", label: "100,000" },
                      { value: "200000", label: "200,000" },
                      { value: "500000", label: "500,000" },
                        { value: "1000000", label: "1,000,000" },
                      { value: "All", label: "All" },
                    ]}
                  />
                )}
              </div>

              <div className="flex flex-col md:flex-row gap-4 mt-6 justify-between items-center">
                <button
                  type="submit"
                  //  disabled={loadingReport}
                  className="bg-mysecondary hover:bg-blue-800 text-white px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm"
                >
                  {/* <Search className="mr-2 h-4 w-4" /> */}
                  {loadingReport ? <TailwindSpinner /> : "Search"}
                </button>
                <div>
                  <button
                    type="button"
                    // disabled={isPending}
                    variant="outline"
                    className=" text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 px-8 py-2 rounded flex items-center justify-center w-[189px] h-[38px] text-sm "
                    onClick={() => handleShowDownloadReport(values)}
                  >
                    {/* <Download className="mr-2 h-4 w-4" /> */}
                    {" Download As"}
                  </button>
                </div>
              </div>
              {showDownloadOption && (
                <div className="flex justify-center  md:justify-end ">
                  <div className="  right-0 mt-2 text-center  border-1 border-mysecondary text-blue-900 hover:bg-blue-50 rounded flex items-center  justify-end w-[189px]  flex-col">
                    <button
                      type="button"
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white"
                      onClick={() => handleDownloadReport(values, "pdf")}
                    >
                      Pdf
                    </button>
                    <button
                      type="button"
                      className="border-b border-blue-900 w-full text-sm py-2 hover:bg-mysecondary hover:text-white"
                      onClick={() => handleDownloadReport(values, "csv")}
                    >
                      Csv
                    </button>
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>

      {campaignReportData?.length > 0 ?(
        <MemberEnrollmentTable
          columns={CampaignReportColumn}
          data={campaignReportData}
          page={page}
          setPage={setPage}
          handlePageChange={handlePageChange}
          totalPage={totalPage}
          loading={loadingReport}
          title={"Campaign"}
        />
      ) :<div className="text-sm text-center text-gray-500 mt-10">
          No data found
        </div> }
      {openModal && (
        <DownloadModal
          setOpenModal={setOpenModal}
          value={formData}
          openModal={openModal}
          payload={payload}
        />
      )}
    </div>
  );
}
